
import React from "react";
import { Link } from "react-router-dom";
import { ThemeSwitcher } from "@/components/ThemeSwitcher";
import { LanguageSwitcher } from "@/components/i18n/LanguageSwitcher";
import { NotificationCenter } from "@/components/notifications/NotificationCenter";
import { UserButton } from "@/components/auth/UserButton";
import { Button } from "@/components/ui/button";
import { TranslationEditButton } from "@/components/i18n/TranslationEditButton";

interface HeaderActionsProps {
  authenticated: boolean;
}

export function HeaderActions({ authenticated }: HeaderActionsProps) {
  if (!authenticated) {
    return (
      <div className="flex items-center gap-2">
        <Button asChild variant="ghost" size="sm">
          <Link to="/login">Log in</Link>
        </Button>
        <Button asChild size="sm">
          <Link to="/register">Sign up</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <TranslationEditButton 
        translationKey="global.editTranslations" 
        tooltipText="Toggle translation edit mode"
        variant="ghost"
        size="sm"
      />
      <ThemeSwitcher />
      {/* <LanguageSwitcher /> - Hidden for now */}
      <NotificationCenter />
      <UserButton />
    </div>
  );
}

